import React from "react";
import { Button } from "semantic-ui-react";

const OrgTreeButton = (props) => {
  const { active, onClick } = props;
  return (
    <Button icon="list ul" color="black" basic={!active} onClick={onClick} />
  );
};

export default OrgTreeButton;
